import React from 'react';
import styled from 'styled-components';
import { PrimaryBtn } from '@panel/commons/lib/Button';
import { selectColor } from '@panel/commons/core';
import { useTranslation } from 'react-i18next';
import Atencion from '../../../assets/img/atencion.svg';
import LockedSoftAlertMessage from '../Alert/LockedSoftAlertMessage';

const LockedSoftModal = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Img src={Atencion} />
      <div>
        <h3>{t('panel.avisos.alert.title.modal.soft')}</h3>
        <p>
          <LockedSoftAlertMessage messageKey='panel.avisos.alert.descrip.modal.soft' />
        </p>
      </div>
      <div className='button-container'>
        <PrimaryBtn type='submit' onClick={onClose} borderRadius='8px' hoverColor='secondary'>
          {t('panel.avisos.alert.CTA1.modal.soft')}
        </PrimaryBtn>
      </div>
    </Container>
  );
};

const Container = styled.div`
  padding: 28px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .button-container {
    width: 50%;
  }

  h3 {
    font-family: Hind;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    white-space: normal;
  }
  p {
    font-family: Hind;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    white-space: normal;
    color: ${selectColor('grayDark')};
  }

  > a {
    height: 48px;
  }
`;

const Img = styled.div`
  background-image: url(${({ src }) => src});
  width: 145px;
  height: 96px;
`;

export default LockedSoftModal;
